var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-category__carousel py-4" }, [
    _vm.title != ""
      ? _c("h4", { staticClass: "u-color-blue-shade-1 mb-2" }, [
          _vm._v(_vm._s(_vm.title)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "carousel--products owl-carousel u-animate__fade-up",
        attrs: { id: _vm.id },
      },
      [
        _vm._l(_vm.items, function (product) {
          return _c(
            "ProductCard",
            _vm._b({ key: product.id }, "ProductCard", product, false)
          )
        }),
        _vm._v(" "),
        _vm.showAllLink
          ? _c(
              "a",
              {
                staticClass: "card--product",
                attrs: { href: _vm.url, "aria-label": _vm.title },
              },
              [
                _c("h4", { staticClass: "card__title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }